import { defineStore } from 'pinia'
import type { Location } from '@/interfaces/Location'
import type { Tenant } from '@/client/types.gen'
import { ref } from 'vue'
import {LocationService} from '@/services/LocationService'
import { TokenService, TenantService } from '@/client'


export const useLocationStore = defineStore('locationStore', () => {
  const locations = ref<Location[]>([])
  const tenants = ref<Tenant[]>([])
  const locationService = new LocationService();
  const getLocations = async () => {
    let response = await locationService.getLocations();
    locations.value = response;
  }
  const setLocation = async (id: string) => {
    await locationService.setLocation(id);
  }
  const setTenant = async (id: string) => {
    return await TokenService.postApiTokenSetTenant({requestBody: {id: id}});
  }
  const getTenants = async () => {
    await TenantService.getApiTenant().then((response) => {
      tenants.value = response;
    });
  }

  return {
    getLocations,
    setLocation,
    setTenant,
    getTenants,

    locations,
    tenants
  }
})
